import * as React from 'react';
import {Outlet} from 'react-router-dom';
import {Link} from 'react-router-dom';
import useActiveEcoRoute from 'hooks/useActiveEcoRoute';
import useEcoRoutes from 'hooks/useEcoRoutes';
import "./MainLayout.scss";
import Title from './components/Title';

type Props = {
    title?: string;
    sidebar?: boolean
};

const MainLayout: React.FC<Props> = ({ sidebar=true }) => {

    const routes = useEcoRoutes() ;
    const pages = routes.filter( route => route.path === '/') ;
    const activeRoute = useActiveEcoRoute() ;

    return (
    <>
        <nav id="navbar-main" className="navbar is-fixed-top">
            <Title title={activeRoute.config.label} />
        </nav> 
            { sidebar &&
                <aside className="aside is-placed-left is-expanded">
                    <div className="aside-tools">
                        <div className="aside-tools-label">
                            <span><b>EcoMundo</b> React</span>
                        </div>
                    </div> 
                    <div className="menu is-menu-main">
                        <p className="menu-label">General</p>
                        {
                        <ul className="menu-list">
                            {pages.length && pages[0] && pages[0].children?.map(
                                (route:any, i) => (
                                <li key={i}>
                                    <span className="icon"><i className="mdi mdi-desktop-mac"></i></span>
                                    <span className="menu-item-label">
                                        <Link className="link" to={route.path} >
                                            {route?.config.label}
                                        </Link>
                                    </span>
                                </li>
                            ))}
                        </ul>
                        }
                    </div>
                </aside>
            }
            <main className="main-content">
            <Outlet />
        </main>
    </>);
}


export default MainLayout;
